import React from 'react';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { Default, Sale, LastSaleDay, SecondUpgrade, ChangePlan } from '.';
import { RootStore } from 'providers';
import { Experiments, PurchaseMode } from 'enums';

export const useHeaderContent = (rootStore: RootStore) => {
  const { purchaseMode } = usePageModeContext();
  const { isSecondUpgrade, isChangePlan, isInSale, experiments } =
    rootStore.appStore;
  const saleBubbleEnabled =
    experiments[Experiments.SunriseV2_EnableSaleBubble] === 'true';

  if (!saleBubbleEnabled && purchaseMode === PurchaseMode.LAST_DAY_SALE) {
    return <LastSaleDay />;
  } else if (!saleBubbleEnabled && isInSale) {
    return <Sale />;
  } else if (isSecondUpgrade) {
    return <SecondUpgrade />;
  } else if (isChangePlan || purchaseMode === PurchaseMode.CHANGE_PLAN) {
    return <ChangePlan />;
  } else {
    return <Default />;
  }
};
